import React from 'react';
import classNames from 'classnames';

import {
  frontend,
  WidgetSelectionRect,
  LinkButton,
  useWidgetConfigurationUpdate
} from 'pageflow-scrolled/frontend';

import styles from './navigationFloatingButton.module.css';

frontend.widgetTypes.register('navigationFloatingButton', {
  component: function Footer({configuration, navigationExpanded}) {
    const updateConfiguration = useWidgetConfigurationUpdate();

    const mobilePosition = configuration.mobilePosition || 'bottom';

    return (
      <div className={classNames(
        styles.bar,
        styles[`mobilePosition-${mobilePosition}`],
        {[styles.expanded]: navigationExpanded
      })}>
        <div className={styles.container}>
          <WidgetSelectionRect>
            <LinkButton className={classNames(styles.button,
                                              'typography-linkButton',
                                              'typography-navigationFloatingButton',
                                              'scope-lightContent',
                                              'scope-navigationFloatingButton',
                                              configuration.linkButtonVariant &&
                                              `scope-linkButton-${configuration.linkButtonVariant}`)}
                        href={configuration.href}
                        openInNewTab={configuration.openInNewTab}
                        value={configuration.text}
                        linkPreviewFloatingStrategy="fixed"
                        actionButtonPosition="topRight"
                        onLinkChange={value => updateConfiguration(value)}
                        onTextChange={text => updateConfiguration({text})} />
          </WidgetSelectionRect>
        </div>
      </div>
    );
  }
});
